import apiClient from '../client';
import type { ProgressCard, CreateProgressCardPayload, UpdateProgressCardPayload } from '@/types';

const BASE = '/admin/progress-cards';

export const progressCardsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: ProgressCard[]; pagination: { total: number } }>(BASE, { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: ProgressCard }>(`${BASE}/${id}`).then((r) => r.data.data),

  create: (payload: CreateProgressCardPayload) =>
    apiClient.post<{ data: ProgressCard }>(BASE, payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateProgressCardPayload) =>
    apiClient.put<{ data: ProgressCard }>(`${BASE}/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`${BASE}/${id}`),
};

